import { cn } from '@tripleten/cn';

export const cnIcon = cn('icon');
